namespace GeniuzPOS.PriceChange {
    export class AddPriceChangeColumns {
        static columnsKey = 'PriceChange.AddPriceChange';
    }
}
